"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { PaymentController } from "@/service/newProdect";
import { Component, PropSync, Vue } from "vue-property-decorator";
import _ from "lodash";
let PaymentNewDashboards = class extends Vue {
  chooseCurrency(paymentType) {
    var _a;
    const paymentchoose = _.find((_a = this._options.selected.categorys) == null ? void 0 : _a.payments, { payment: paymentType });
    if (paymentchoose) {
      return paymentchoose.currency;
    } else {
      return "CNY";
    }
  }
};
__decorateClass([
  PropSync("options", {
    default: function() {
      return new PaymentController();
    }
  })
], PaymentNewDashboards.prototype, "_options", 2);
__decorateClass([
  PropSync("paymentStyle", {
    default: function() {
      return "";
    }
  })
], PaymentNewDashboards.prototype, "_payment_style", 2);
PaymentNewDashboards = __decorateClass([
  Component({
    filters: {
      numFilter: (value) => {
        if (value === "-") {
          return value;
        }
        return Number(value).toFixed(2);
      }
    }
  })
], PaymentNewDashboards);
export {
  PaymentNewDashboards as default
};
